"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcCarouselBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var bc_abstract_swipe_behavior_1 = require("./bc-abstract-swipe-behavior");
var bc_carousel_constants_1 = require("./bc-carousel-constants");
var bc_carousel_constants_2 = require("./bc-carousel-constants");
var bc_carousel_constants_3 = require("./bc-carousel-constants");
var bc_carousel_constants_4 = require("./bc-carousel-constants");
var bc_carousel_constants_5 = require("./bc-carousel-constants");
var bc_carousel_constants_6 = require("./bc-carousel-constants");
var bc_carousel_constants_7 = require("./bc-carousel-constants");
var bc_carousel_constants_8 = require("./bc-carousel-constants");
var bc_carousel_constants_9 = require("./bc-carousel-constants");
var bc_carousel_constants_10 = require("./bc-carousel-constants");
var bc_carousel_constants_11 = require("./bc-carousel-constants");
var bc_carousel_constants_12 = require("./bc-carousel-constants");
var bc_carousel_constants_13 = require("./bc-carousel-constants");
var bc_carousel_constants_14 = require("./bc-carousel-constants");
var bc_carousel_constants_15 = require("./bc-carousel-constants");
var bc_carousel_constants_16 = require("./bc-carousel-constants");
var bc_carousel_constants_17 = require("./bc-carousel-constants");
var bc_carousel_constants_18 = require("./bc-carousel-constants");
var bc_carousel_constants_19 = require("./bc-carousel-constants");
var bc_carousel_constants_20 = require("./bc-carousel-constants");
var bc_carousel_constants_21 = require("./bc-carousel-constants");
var bc_carousel_constants_22 = require("./bc-carousel-constants");
var bc_carousel_constants_23 = require("./bc-carousel-constants");
var bc_carousel_constants_24 = require("./bc-carousel-constants");
var bc_carousel_constants_25 = require("./bc-carousel-constants");
var bc_carousel_constants_26 = require("./bc-carousel-constants");
var bc_carousel_constants_27 = require("./bc-carousel-constants");
var bc_carousel_constants_28 = require("./bc-carousel-constants");
var bc_carousel_constants_29 = require("./bc-carousel-constants");
var bc_carousel_constants_30 = require("./bc-carousel-constants");
var bc_carousel_constants_31 = require("./bc-carousel-constants");
var bc_carousel_constants_32 = require("./bc-carousel-constants");
var bc_carousel_constants_33 = require("./bc-carousel-constants");
var BcCarouselBehavior = (function (_super) {
    __extends(BcCarouselBehavior, _super);
    function BcCarouselBehavior() {
        var _this = _super.call(this) || this;
        _this.options = null;
        _this.slidesElements = [];
        _this.currentIndex = 0;
        _this.currentSlide = 0;
        _this.slideCount = 0;
        _this.pageNumber = '';
        _this.prevArrow = null;
        _this.nextArrow = null;
        _this.bulletContent = null;
        _this.slidesTrack = null;
        _this.bullets = [];
        _this.sliderWidth = 0;
        _this.slideWidth = 0;
        _this.slideOffset = 0;
        _this.slideTrackWidth = 0;
        _this.interval = 0;
        _this.defaultIntervalTimeout = bc_carousel_constants_33.CAROUSEL_DEFAULT_INTERVAL_TIMEOUT;
        _this.hideElement = function (el, hide) {
            if (hide) {
                el.classList.add(bc_carousel_constants_16.CAROUSEL_HIDE_CLASS);
                el.setAttribute(bc_carousel_constants_1.CAROUSEL_ARIA_HIDDEN, 'true');
            }
            else {
                el.classList.remove(bc_carousel_constants_16.CAROUSEL_HIDE_CLASS);
                el.setAttribute(bc_carousel_constants_1.CAROUSEL_ARIA_HIDDEN, 'false');
            }
        };
        return _this;
    }
    BcCarouselBehavior.prototype._setUp = function () {
        this.initOptions();
        this.initilize();
        this.setConfiguration();
        _super.prototype._setUp.call(this);
        this.addEventListener();
    };
    BcCarouselBehavior.prototype.setOptions = function (options) {
        this.options = options;
        this.initOptions();
    };
    BcCarouselBehavior.prototype.createItems = function () {
        var _this = this;
        if (this.options && this.options.items.length > 0) {
            var items = this.options.items;
            items.forEach(function (item, i) {
                var li = _this.createItem(item);
                _this.slidesElements[i] = li;
            });
            var content = this.mySelf.querySelector("".concat(common_constants_1.BcCommonConstants.SECTION_TAG, ".").concat(bc_carousel_constants_7.CAROUSEL_LIST_CLASS));
            content.innerHTML = '';
            content.appendChild((0, helpers_1.createElement)({
                element: common_constants_1.BcCommonConstants.UL_TAG,
                classList: [bc_carousel_constants_8.CAROUSEL_TRACK_CLASS],
                children: this.slidesElements
            }));
            this.setSlideCount(items.length);
        }
    };
    BcCarouselBehavior.prototype.setSlideCount = function (nSlides) {
        this.slideCount = nSlides;
    };
    BcCarouselBehavior.prototype.initilize = function () {
        this.getContentItems();
        this.checkItems();
        this.buildBullets();
        this.addArrows();
        this.setupInfinite();
        this.setPosition();
        this.updateBullets();
        this.updateArrows();
        this.setupAutoPlay();
        this.changeDataAccessibility();
    };
    BcCarouselBehavior.prototype.changeDataAccessibility = function () {
        var amountOfItems = this.mySelf.querySelectorAll(".".concat(bc_carousel_constants_9.CAROUSEL_ITEM_CLASS));
        var lengthItems = amountOfItems.length;
        amountOfItems.forEach(function (item, i) {
            item.setAttribute(bc_carousel_constants_26.CAROUSEL_ARIA_LABEL, "".concat(i + 1, " de ").concat(lengthItems));
            item.setAttribute(bc_carousel_constants_31.CAROUSEL_ARIA_ROL_DESCRIPTION, 'slide');
            item.setAttribute(bc_carousel_constants_32.CAROUSEL_ROL_ITEM, 'group');
        });
        this.mySelf.setAttribute(bc_carousel_constants_31.CAROUSEL_ARIA_ROL_DESCRIPTION, 'carousel');
    };
    BcCarouselBehavior.prototype.buildBullets = function () {
        if (!this.options.bullets) {
            return;
        }
        if (this.options.bullets === true && this.slideCount > this.options.slidesToShow) {
            var bulletsQty = this.getBulletQty();
            for (var i = 0; i < bulletsQty; i += 1) {
                this.bullets[i] = this.createBullet();
            }
            this.getArrows();
            if (this.options.arrowsInBullets) {
                this.bullets.push(this.nextArrow);
                this.bullets.unshift(this.prevArrow);
            }
            this.createBulletsContent();
            this.mySelf.append(this.bulletContent);
            this.bullets[1].classList.add(bc_carousel_constants_24.CAROUSEL_ACTIVE_BULLET_CLASS);
        }
    };
    BcCarouselBehavior.prototype.updateBullets = function () {
        if (this.bullets && this.bullets.length > 0) {
            var bulletActive = this.bullets.find(function (el) { return el.classList.contains(bc_carousel_constants_24.CAROUSEL_ACTIVE_BULLET_CLASS); });
            this.bulletRemove(bulletActive);
            var index = this.getBulletPosByIndex();
            var bulletToActive = void 0;
            bulletToActive = this.bulletsToActivate(index, bulletToActive);
            this.bulletActiveRemove(bulletToActive);
        }
    };
    BcCarouselBehavior.prototype.bulletsToActivate = function (index, bulletToActive) {
        if (this.options.arrowsInBullets) {
            if (index && this.bullets[index].classList[0] === "".concat(bc_carousel_constants_2.CAROUSEL_CLASS, "-arrow")) {
                bulletToActive = this.bullets[1];
            }
            else if (index === this.bullets.length && this.bullets[index].classList[0] === "".concat(bc_carousel_constants_2.CAROUSEL_CLASS, "-arrow")) {
                var indexArrow = this.bullets.length - 1;
                bulletToActive = this.bullets[indexArrow];
            }
            else {
                bulletToActive = this.bullets[index];
            }
        }
        else {
            bulletToActive = this.bullets[index];
        }
        return bulletToActive;
    };
    BcCarouselBehavior.prototype.bulletRemove = function (bulletActive) {
        if (bulletActive) {
            bulletActive.classList.remove(bc_carousel_constants_24.CAROUSEL_ACTIVE_BULLET_CLASS);
        }
    };
    BcCarouselBehavior.prototype.bulletActiveRemove = function (bulletToActive) {
        if (bulletToActive) {
            bulletToActive.classList.add(bc_carousel_constants_24.CAROUSEL_ACTIVE_BULLET_CLASS);
        }
    };
    BcCarouselBehavior.prototype.getBulletPosByIndex = function () {
        return Math.ceil(this.currentSlide / this.options.slidesToScroll);
    };
    BcCarouselBehavior.prototype.createBulletsContent = function () {
        this.bulletContent = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_carousel_constants_21.CAROUSEL_BULLETS_CLASS],
            children: [
                (0, helpers_1.createElement)({
                    element: common_constants_1.BcCommonConstants.UL_TAG,
                    children: this.bullets
                })
            ]
        });
    };
    BcCarouselBehavior.prototype.createNumberPaginator = function () {
        var contentItems = this.mySelf.querySelector(".".concat(bc_carousel_constants_5.CAROUSEL_CONTENT_NUMBER_PAGINATOR_CLASS, " > ").concat(common_constants_1.BcCommonConstants.P_TAG));
        if (!contentItems) {
            var content = (0, helpers_1.createElement)({
                element: common_constants_1.BcCommonConstants.DIV_TAG,
                classList: [bc_carousel_constants_5.CAROUSEL_CONTENT_NUMBER_PAGINATOR_CLASS],
                children: [
                    (0, helpers_1.createElement)({
                        element: common_constants_1.BcCommonConstants.P_TAG,
                        innerText: this.pageNumber,
                    })
                ]
            });
            this.mySelf.append(content);
        }
        else {
            contentItems.innerHTML = this.pageNumber;
        }
    };
    BcCarouselBehavior.prototype.createBullet = function () {
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.LI_TAG,
            classList: [bc_carousel_constants_22.CAROUSEL_BULLET_ITEM_CLASS],
            children: [
                (0, helpers_1.createElement)({
                    element: common_constants_1.BcCommonConstants.BUTTON_TAG,
                    classList: [bc_carousel_constants_23.CAROUSEL_BULLET_CLASS],
                })
            ],
        });
    };
    BcCarouselBehavior.prototype.getBulletQty = function () {
        var _a = this.options, slidesToScroll = _a.slidesToScroll, slidesToShow = _a.slidesToShow;
        return ((this.slideCount - slidesToShow) / slidesToScroll) + common_constants_1.COMMON_CONSTANTS_NUMBERS.N1;
    };
    BcCarouselBehavior.prototype.initOptions = function () {
        this.options = __assign({ spacingBetweenItems: bc_carousel_constants_20.CAROUSEL_ITEMS_SPACE_BETWEEN, iconNamePrev: bc_carousel_constants_17.CAROUSEL_CONTROL_LEFT_NAME, iconNameNext: bc_carousel_constants_18.CAROUSEL_CONTROL_RIGHT_NAME, swipeSpeed: bc_carousel_constants_19.CAROUSEL_SWIPE_SPEED, items: [], arrows: true, bullets: false, accessibility: true, initialSlide: 0, slidesToShow: 1, slidesToScroll: 1, swipe: true, variableWidth: false, infinity: false, gridSystem: false, arrowsInBullets: false, autoPlay: false, sliderPagination: false, autoplayTimeout: 4000 }, (this.options || {}));
        this.currentSlide = this.options.initialSlide;
    };
    BcCarouselBehavior.prototype.setupInfinite = function () {
        if (!this.options.infinity) {
            return;
        }
    };
    BcCarouselBehavior.prototype.pauseAutoPlay = function () {
        clearInterval(this.interval);
    };
    BcCarouselBehavior.prototype.listenerMoveItem = function () {
        var _this = this;
        var screenXInitial = 0;
        var screenXEnd = 0;
        var listenerItem = this.mySelf.querySelector(".".concat(bc_carousel_constants_8.CAROUSEL_TRACK_CLASS));
        listenerItem.addEventListener(common_constants_1.BcCommonConstants.EVENT_MOUSEDOWN, function (e) {
            screenXInitial = e.clientX;
        });
        listenerItem.addEventListener(common_constants_1.BcCommonConstants.EVENT_MOUSEUP, function (e) {
            screenXEnd = e.clientX;
            if (screenXInitial !== screenXEnd) {
                _this.pauseAutoPlay();
            }
        });
    };
    BcCarouselBehavior.prototype.setupAutoPlay = function () {
        var _this = this;
        if (this.options.autoPlay && this.bullets && this.bullets.length > 0) {
            this.listenerMoveItem();
            if (!this.interval) {
                this.interval = setInterval(function () {
                    var activeBullet = _this.bullets.find(function (el) { return el.classList.contains(bc_carousel_constants_24.CAROUSEL_ACTIVE_BULLET_CLASS); });
                    if (activeBullet) {
                        var nextBullet = activeBullet.nextElementSibling;
                        if (nextBullet == null || !nextBullet.classList.contains(bc_carousel_constants_22.CAROUSEL_BULLET_ITEM_CLASS)) {
                            nextBullet = _this.bullets[0];
                        }
                        nextBullet.dispatchEvent(new Event(common_constants_1.BcCommonConstants.EVENT_CLICK));
                    }
                }, this.defaultIntervalTimeout || this.options.autoplayTimeout);
            }
        }
    };
    BcCarouselBehavior.prototype.addEventListener = function () {
        this.onCLick(this.prevArrow, this.onLeftClick);
        this.onCLick(this.nextArrow, this.onRightClick);
        this.bulletsEventListeners();
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_RESIZE, this.setDimensions.bind(this));
    };
    BcCarouselBehavior.prototype.bulletsEventListeners = function () {
        var _this = this;
        if (this.options.bullets && this.slideCount > this.options.slidesToShow) {
            var leftTo_1 = Math.ceil(this.slideTrackWidth / this.getBulletQty());
            if (this.options.arrowsInBullets) {
                this.bullets.shift();
                this.bullets.pop();
            }
            this.bullets.forEach(function (el, i) {
                el.setAttribute(bc_carousel_constants_29.CAROUSEL_MOVE_TO, (leftTo_1 * i).toString());
                el.setAttribute(bc_carousel_constants_1.CAROUSEL_STEP, (_this.config.step * i).toString());
                el.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
                    var index = el.getAttribute(bc_carousel_constants_1.CAROUSEL_STEP);
                    var moveTo = _this.getValidLeft(index, false);
                    _this.moveSliderTo(moveTo);
                });
            });
        }
    };
    BcCarouselBehavior.prototype.getValidLeft = function (leftTo, updateComponent) {
        if (updateComponent === void 0) { updateComponent = false; }
        leftTo = typeof leftTo === bc_carousel_constants_30.IS_STRING ? parseInt(leftTo) : leftTo;
        leftTo = leftTo < 0 ? leftTo * -1 : leftTo;
        var moveTo = this.moveValidLeft(leftTo);
        this.currentSlide = Math.floor(moveTo / this.slideWidth);
        if (updateComponent) {
            this.updateArrows();
            this.updateBullets();
        }
        return moveTo * -1;
    };
    BcCarouselBehavior.prototype.moveValidLeft = function (leftTo) {
        var length = this.slideCount;
        var moveTo = 0, i = 0;
        for (i; i < length; i++) {
            var from = this.slideWidth * i;
            var to = from + this.slideWidth / bc_carousel_constants_19.CAROUSEL_SWIPE_SPEED;
            var next = this.slideWidth * (i + 1);
            if (i == length - 1 && leftTo >= from) {
                moveTo = from;
            }
            else if (from <= leftTo && to >= leftTo) {
                moveTo = from;
            }
            else if (i < length - 1 && to <= leftTo && next >= leftTo) {
                moveTo = next;
            }
        }
        return moveTo;
    };
    BcCarouselBehavior.prototype.onCLick = function (control, event) {
        event = event.bind(this);
        control.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (e) {
            event(e);
        });
        (0, helpers_1.addFocusable)(control, {}, { event: event });
    };
    BcCarouselBehavior.prototype.createItem = function (item) {
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.LI_TAG,
            classList: [
                bc_carousel_constants_9.CAROUSEL_ITEM_CLASS,
                "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-mx-").concat(this.options.spacingBetweenItems),
                "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-my-3"),
                (item.hidden ? common_constants_1.BcCommonConstants.INVISIBLE_CLASS : '_')
            ],
            children: [
                item.content
            ]
        });
    };
    BcCarouselBehavior.prototype.getSlidesTrack = function () {
        var slidesTrack = this.mySelf.querySelector("*.".concat(bc_carousel_constants_8.CAROUSEL_TRACK_CLASS));
        if (slidesTrack) {
            this.slidesTrack = slidesTrack;
            return;
        }
        this.buildSlidesTrack();
    };
    BcCarouselBehavior.prototype.buildSlidesTrack = function () {
        var slidesTrack = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_carousel_constants_8.CAROUSEL_TRACK_CLASS],
        });
        this.containerItems.append(slidesTrack);
        this.slidesTrack = slidesTrack;
    };
    BcCarouselBehavior.prototype.getContentItems = function () {
        var contentItems = this.mySelf.querySelector(".".concat(bc_carousel_constants_7.CAROUSEL_LIST_CLASS));
        if (contentItems) {
            this.containerItems = contentItems;
            this.addIdClassList();
            return;
        }
        this.buildContentItems();
    };
    BcCarouselBehavior.prototype.addIdClassList = function () {
        var contentItems = this.mySelf.querySelector(".".concat(bc_carousel_constants_7.CAROUSEL_LIST_CLASS));
        contentItems.id = "".concat(bc_carousel_constants_7.CAROUSEL_LIST_CLASS, "-").concat(this.mySelf.getAttribute(common_constants_1.BcCommonConstants.ID));
    };
    BcCarouselBehavior.prototype.buildContentItems = function () {
        var content = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.SECTION_TAG,
            classList: [bc_carousel_constants_7.CAROUSEL_LIST_CLASS],
        });
        this.mySelf.append(content);
        this.containerItems = content;
        this.addIdClassList();
    };
    BcCarouselBehavior.prototype.cleanItems = function () {
        this.options.items = [];
        this.slidesElements = [];
    };
    BcCarouselBehavior.prototype.checkItems = function () {
        if (this.options.gridSystem) {
            this.addGridOut();
            this.getGridItems();
            return;
        }
        this.getItems();
    };
    BcCarouselBehavior.prototype.addGridOut = function () {
        this.mySelf.classList.add(bc_carousel_constants_6.CAROUSEL_GRID_CLASS);
    };
    BcCarouselBehavior.prototype.addIdItemGrid = function (data) {
        data.forEach(function (item, i) {
            item.id = "slide-".concat(i);
        });
    };
    BcCarouselBehavior.prototype.getGridItems = function () {
        var items = Array.from(this.mySelf.querySelectorAll("*.".concat(bc_carousel_constants_9.CAROUSEL_ITEM_CLASS)));
        var itemsRowSlide = Array.from(this.mySelf.querySelectorAll("*.".concat(bc_carousel_constants_10.CAROUSEL_ROW_CLASS)));
        if (items.length == 0) {
            this.createGridItems();
            return;
        }
        else if (itemsRowSlide.length > 0) {
            this.addIdItemGrid(items);
            this.slidesElements = itemsRowSlide;
            this.loadItemGrid(itemsRowSlide);
            return;
        }
        this.cleanItems();
        this.loadGridItemsObject(items);
    };
    BcCarouselBehavior.prototype.loadGridItemsObject = function (items) {
        var _this = this;
        items.forEach(function (item, i) {
            _this.checkSpacing(item);
        });
        this.setSlideCount(items.length);
    };
    BcCarouselBehavior.prototype.createGridItems = function () {
        var _this = this;
        if (this.options && this.options.items.length > 0) {
            var items = this.options.items;
            items.forEach(function (item, i) {
                var li = _this.createGridItem(item);
                _this.slidesElements[i] = li;
            });
            var content = this.mySelf.querySelector("".concat(common_constants_1.BcCommonConstants.SECTION_TAG, ".").concat(bc_carousel_constants_7.CAROUSEL_LIST_CLASS));
            content.innerHTML = '';
            content.appendChild((0, helpers_1.createElement)({
                element: common_constants_1.BcCommonConstants.UL_TAG,
                classList: [bc_carousel_constants_8.CAROUSEL_TRACK_CLASS],
                children: this.slidesElements
            }));
        }
    };
    BcCarouselBehavior.prototype.loadItemGrid = function (items) {
        var _this = this;
        items.forEach(function (item) {
            for (var _i = 0, _a = item.children; _i < _a.length; _i++) {
                var element = _a[_i];
                if (!element.classList.contains(bc_carousel_constants_10.CAROUSEL_ROW_CLASS)) {
                    element.classList.add(bc_carousel_constants_11.CAROUSEL_CELL_CLASS, "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-m-").concat(_this.options.spacingBetweenItems));
                }
                _this.setSlideCount(_this.slideCount + 1);
            }
        });
    };
    BcCarouselBehavior.prototype.createGridItem = function (item) {
        var _this = this;
        var div = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            props: { id: "slide-".concat(item.uid) },
            classList: __spreadArray(__spreadArray([], (item.typeDesign === 'row' ?
                [bc_carousel_constants_10.CAROUSEL_ROW_CLASS]
                : [
                    bc_carousel_constants_9.CAROUSEL_ITEM_CLASS,
                    bc_carousel_constants_11.CAROUSEL_CELL_CLASS,
                    "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-m-").concat(this.options.spacingBetweenItems),
                    (item.colspan ? "".concat(bc_carousel_constants_12.CAROUSEL_COLSPAN_CLASS, "-").concat(item.colspan) : '_'),
                ]), true), [
                (item.hidden ? common_constants_1.BcCommonConstants.INVISIBLE_CLASS : '_')
            ], false),
        });
        if (item.content) {
            div.append(item.content);
            this.setSlideCount(this.slideCount + 1);
            return div;
        }
        item.children.forEach(function (child) {
            var el = _this.createGridItem(child);
            div.append(el);
        });
        return div;
    };
    BcCarouselBehavior.prototype.getItems = function () {
        var _this = this;
        var items = Array.from(this.mySelf.querySelectorAll("*.".concat(bc_carousel_constants_9.CAROUSEL_ITEM_CLASS)));
        if (items.length == 0) {
            this.createItems();
            return;
        }
        this.cleanItems();
        items.forEach(function (item, i) {
            _this.checkSpacing(item);
            _this.options.items[i] = {
                content: item,
                order: i,
                hidden: item.classList.contains(common_constants_1.BcCommonConstants.INVISIBLE_CLASS)
            };
            _this.slidesElements[i] = item;
        });
        this.setSlideCount(items.length);
    };
    BcCarouselBehavior.prototype.checkSpacing = function (slide) {
        var pascingBetweenSlides = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-mx-").concat(this.options.spacingBetweenItems);
        var pascingTopBottom = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-my-3");
        if (!slide.classList.contains(pascingBetweenSlides)) {
            slide.classList.add(pascingBetweenSlides);
        }
        if (!slide.classList.contains(pascingTopBottom)) {
            slide.classList.add(pascingTopBottom);
        }
    };
    BcCarouselBehavior.prototype.setDimensions = function () {
        var _this = this;
        var list = this.mySelf.querySelector("".concat(common_constants_1.BcCommonConstants.SECTION_TAG, ".").concat(bc_carousel_constants_7.CAROUSEL_LIST_CLASS));
        var itemsRowSlide = Array.from(this.mySelf.querySelectorAll("*.".concat(bc_carousel_constants_10.CAROUSEL_ROW_CLASS)));
        var trackWidth = 0;
        this.getSlidesTrack();
        this.sliderWidth = list.clientWidth;
        this.slideWidth = Math.ceil(this.sliderWidth / this.options.slidesToShow);
        var items = this.mySelf.querySelectorAll(".".concat(bc_carousel_constants_9.CAROUSEL_ITEM_CLASS, " > *"));
        if (this.options.variableWidth) {
            trackWidth = bc_carousel_constants_1.COROUSEL_TRACK_WIDTH * this.slideCount;
        }
        else if (this.options.gridSystem && this.options.items && this.options.items.length > 0) {
            this.options.items.forEach(function (item) {
                var el = _this.mySelf.querySelector("#slide-".concat(item.uid, " > *"));
                var offsetWidth = (0, helpers_1.getOffsetWidth)(el.parentElement);
                el.style.width = "".concat((_this.slideWidth - offsetWidth), "px");
                trackWidth += (_this.slideWidth);
                _this.slideOffset = offsetWidth;
            });
        }
        else if (this.options.gridSystem && itemsRowSlide) {
            itemsRowSlide.forEach(function (item, i) {
                item.id = "slide-row-".concat(i);
                var el = _this.mySelf.querySelector("#".concat(item.id, " > *"));
                var offsetWidth = (0, helpers_1.getOffsetWidth)(el.parentElement);
                el.style.width = "".concat((_this.slideWidth - offsetWidth), "px");
                trackWidth += (_this.slideWidth);
                _this.slideOffset = offsetWidth;
            });
        }
        else if (items && items.length > 0) {
            items.forEach(function (el, i) {
                el.id = "slide-".concat(i);
                var offsetWidth = (0, helpers_1.getOffsetWidth)(el.parentElement);
                el.style.width = "".concat((_this.slideWidth - offsetWidth), "px");
                trackWidth += (_this.slideWidth);
                _this.slideOffset = offsetWidth;
            });
        }
        this.slidesTrack.style.width = "".concat(trackWidth, "px");
        this.slideTrackWidth = trackWidth;
    };
    BcCarouselBehavior.prototype.setPosition = function () {
        this.setDimensions();
        this.setCSS(this.getLeftByIndex(this.currentSlide));
    };
    BcCarouselBehavior.prototype.getLeftByIndex = function (slideIndex) {
        var targetLeft, targetSlide;
        this.slideOffset = 0;
        if (slideIndex + this.options.slidesToShow > this.slideCount) {
            this.slideOffset = ((slideIndex + this.options.slidesToShow) - this.slideCount) * this.slideWidth;
        }
        if (this.slideCount <= this.options.slidesToShow) {
            this.slideOffset = 0;
        }
        targetLeft = ((slideIndex * this.slideWidth) * -1) + this.slideOffset;
        if (this.options.variableWidth === true) {
            targetSlide = this.slidesElements[slideIndex];
            targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
        }
        return targetLeft;
    };
    BcCarouselBehavior.prototype.addArrows = function () {
        if (this.options.arrows && !this.options.arrowsInBullets) {
            this.getArrows();
            if (!this.mySelf.querySelector(".".concat(bc_carousel_constants_4.CAROUSEL_CONTAINER_TOP_BUTTON_CLASS)) && !this.mySelf.querySelector(".".concat(bc_carousel_constants_3.CAROUSEL_CONTAINER_BOTTOM_BUTTON_CLASS))) {
                this.mySelf.prepend(this.prevArrow);
                this.mySelf.append(this.nextArrow);
            }
        }
    };
    BcCarouselBehavior.prototype.getArrows = function () {
        this.prevArrow = this.getArrow(bc_carousel_constants_14.CAROUSEL_ARROW_PREV_CLASS, this.options.iconNamePrev);
        this.nextArrow = this.getArrow(bc_carousel_constants_15.CAROUSEL_ARROW_NEXT_CLASS, this.options.iconNameNext);
    };
    BcCarouselBehavior.prototype.changeAttributeButton = function (className, item) {
        item.setAttribute(bc_carousel_constants_1.CAROUSEL_ARIA_HIDDEN, 'false');
        var contentItems = this.mySelf.querySelector(".".concat(bc_carousel_constants_7.CAROUSEL_LIST_CLASS));
        if (className === bc_carousel_constants_14.CAROUSEL_ARROW_PREV_CLASS) {
            item.setAttribute(bc_carousel_constants_26.CAROUSEL_ARIA_LABEL, bc_carousel_constants_28.CAROUSEL_TEXT_SLIDE_PREV);
        }
        else {
            item.setAttribute(bc_carousel_constants_26.CAROUSEL_ARIA_LABEL, bc_carousel_constants_27.CAROUSEL_TEXT_SLIDE_NEXT);
        }
        item.setAttribute(bc_carousel_constants_25.CAROUSEL_ARIA_CONTROLS, contentItems.id);
        item.tabIndex = "0";
        return item;
    };
    BcCarouselBehavior.prototype.getArrow = function (className, iconName) {
        var button = this.mySelf.querySelector(".".concat(className));
        if (!button) {
            button = this.createArrow(className, iconName);
        }
        else {
            button = this.changeAttributeButton(className, button);
        }
        return button;
    };
    BcCarouselBehavior.prototype.createArrow = function (className, iconName) {
        var button = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_carousel_constants_13.CAROUSEL_ARROW_CLASS, className],
            children: [
                (0, helpers_1.createElement)({
                    element: common_constants_1.BcCommonConstants.I_TAG,
                    classList: [common_constants_1.BcCommonConstants.ICONS_CLASS],
                    innerText: iconName,
                }),
            ]
        });
        return this.changeAttributeButton(className, button);
    };
    BcCarouselBehavior.prototype.updateArrows = function () {
        if (this.options.arrows && this.slideCount > this.options.slidesToShow && !this.options.infinity) {
            this.getArrows();
            this.hideArrows(false);
            if (this.currentSlide === 0) {
                this.hideElement(this.prevArrow, true);
                this.hideElement(this.nextArrow, false);
            }
            else if (this.currentSlide >= this.slideCount - this.options.slidesToShow) {
                this.hideElement(this.prevArrow, false);
                this.hideElement(this.nextArrow, true);
            }
        }
        if (this.options.sliderPagination) {
            this.pageNumber = "".concat(this.currentSlide + 1, "/").concat(this.slideCount);
            this.createNumberPaginator();
        }
    };
    BcCarouselBehavior.prototype.hideArrows = function (hide) {
        this.hideElement(this.prevArrow, hide);
        this.hideElement(this.nextArrow, hide);
    };
    BcCarouselBehavior.prototype.setConfiguration = function () {
        this.setConfig({
            speed: this.options.swipeSpeed,
            contentItemsClass: bc_carousel_constants_8.CAROUSEL_TRACK_CLASS,
            sliderClass: bc_carousel_constants_2.CAROUSEL_CLASS,
            onMoving: this.onSwipe.bind(this),
            step: this.options.slidesToScroll * this.slideWidth,
            infinity: this.options.infinity,
        });
    };
    BcCarouselBehavior.prototype.onLeftClick = function () {
        this.pauseAutoPlay();
        this.moveSliderToLeft(true);
        this.getValidLeft(this.target, true);
    };
    BcCarouselBehavior.prototype.onRightClick = function () {
        this.pauseAutoPlay();
        this.moveSliderToLeft(false);
        this.getValidLeft(this.target, true);
    };
    BcCarouselBehavior.prototype.onSwipe = function (newLeft) {
        this.getValidLeft(newLeft, true);
    };
    return BcCarouselBehavior;
}(bc_abstract_swipe_behavior_1.BcAbstractSwipeBehavior));
exports.BcCarouselBehavior = BcCarouselBehavior;
